import * as React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

import styles from './StatisticsPage.scss';
import { StatisticsPageLocale } from './statisticsPage.locale';
import Header from '../Header/Header';
import Tabs from '../Tabs/Tabs';
import SliderContainer from '../../containers/StatisticsPage/Slider/Slider';
import Cta from '../Cta/Cta';
import LinkButton from '../../components/Button/LinkButton';
import { Query } from '../../GraphQL';

interface StatisticsPageProps {
  locale: StatisticsPageLocale;
  traffics: Query['traffics'][];
  activeGraphIndex: number;
  setActiveGraph: (index: number) => void;
  sliderRef: React.RefObject<Slider>;
  loading: boolean;
}

const StatisticsPage: React.SFC<StatisticsPageProps> = ({
  locale,
  traffics,
  activeGraphIndex,
  setActiveGraph,
  sliderRef,
  loading,
}) => (
  <>
    <Header title={locale.title} />
    <main className={styles.mainSection}>
      <div className={styles.tabs}>
        <Tabs
          buttons={locale.graphs.map((graph, index) => ({
            text: graph.periodText,
            onClick: () => (sliderRef.current ? sliderRef.current.slickGoTo(index) : undefined),
            isActive: activeGraphIndex === index,
          }))}
          theme="dark"
        />
      </div>
      <SliderContainer
        locale={locale}
        traffics={traffics}
        setActiveGraph={setActiveGraph}
        sliderRef={sliderRef}
        loading={loading}
      />
      <Cta title={locale.cta.title} backgroundType="circles">
        <LinkButton to={locale.cta.button.href}>{locale.cta.button.text}</LinkButton>
      </Cta>
    </main>
  </>
);

export default StatisticsPage;



// WEBPACK FOOTER //
// /www/client/src/components/StatisticsPage/StatisticsPage.tsx